import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../components/ui/dialog';

const ReferralDialog: React.FC = () => {
  const [openReferralDialog, setOpenReferralDialog] = useState(false);
  const [isCollected, setIsCollected] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    const url = new URLSearchParams(window.location.search)
    const referralCode = url.get('referral-code')

    if (referralCode) {
      setOpenReferralDialog(true);
      // const urlObj = new URL(window.location.href);
      // urlObj.searchParams.delete('referral-code');
      // window.history.replaceState({}, '', urlObj.toString());
    }
  }, [])

  const handleCollect = () => {
    setIsCollected(true);
  }

  const handleViewRewards = () => {
    navigate('/aye-face-reward/my-rewards');
  }

  
  return (
    <Dialog open={openReferralDialog} onOpenChange={setOpenReferralDialog}>
      <DialogContent className={`max-w-[24rem] rounded-3xl`}>
        <DialogHeader>
          <DialogTitle className='font-normal mt-8'>
            {isCollected
              ? "Congratulations!"
              : "Your Referee Reward is Here!"}
          </DialogTitle>
        </DialogHeader>

        <div className='m-2 flex flex-col items-center'>
          <p className='text-center mb-8'>
            {isCollected
              ? "You’ve earned referral reward of [amount] [reward type]!"
              : "Claim your [amount] [reward type] reward now and start using AyeFace to unlock even more rewards!"}
          </p>

          {isCollected ? (
            <Button
              className='w-64 mb-2'
              onClick={handleViewRewards}
            >
              View My Rewards
            </Button>
          ) : (
            <Button
              className='w-64 mb-2'
              onClick={handleCollect}
            >
              Claim Reward
            </Button>
          )}

          {!isCollected && (
            <p className='text-black/70 text-xs italic'>
              You won't see this again if you cancel it
            </p>
          )}
        </div>

        {isCollected && (
          <div className='absolute px-4'>
            <img src="/assets/congratz-bg.png" />
          </div>
        )}

      </DialogContent>
    </Dialog>
  )
}

export default ReferralDialog;